module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./TransactionListView.js"));
	}, "TransactionListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransactionListView!./src/pages/Shop/Member/Wallet/TransactionList/TransactionListView.js
// module id = 1075
// module chunks = 431